<template>
  <section class="home">
    <base-modal v-if="showModal">
      <template v-slot:content>
        <UserDetailsCapture
          @closeModalPopUp="closeModalPopUp"
          @showTerms="showTerms"
        ></UserDetailsCapture>
      </template>
      <template v-slot:terms>
        <TermsAndConditionsWrapper v-if="showTermsAndConditions"></TermsAndConditionsWrapper>
      </template>
    </base-modal>
    <div class="container">
      <div
        class="homepage-message"
        :class="{ 'hide-message': showSearchWithResults }"
      >
        Search our extensive player database to find out if a footballer is
        likely to be eligible to play in the UK.
      </div>
      <div
        class="search"
        :class="{ 'search-with-results': showSearchWithResults }"
      >
        <div class="search-area area-holder theme-button">
          <input
            class="input-field"
            v-model.trim="searchString"
            @keypress.enter="searchForPlayer"
            placeholder="Search player e.g. Aubameyang"
            ref="inputRef"
          />
          <button @click="searchForPlayer" class="normal-state">
            <font-awesome-icon
              class="button-icon"
              :icon="['fal', 'search']"
            ></font-awesome-icon
            >Search players
          </button>
        </div>
        <div class="search-powered-by">
          <span>Powered by:</span>
          <a href="https://analyticsfc.co.uk/transferlab/" target="_blank"
            ><img src="/TransferLab-White.png"
          /></a>
        </div>
        <div
          class="details"
          :class="{ 'details-results': searchData }"
          v-if="searchData && searchData.length > 0"
        >
          <div
            v-for="(playerData, index) in searchData"
            :key="index"
            class="details-display"
            @click="getPlayerDetails(playerData)"
          >
            <div class="details-display-image">
              <img
                :src="`https://faimages.lcp.uk.com/players/${playerData.id}.png`"
              />
            </div>
            <div class="details-display-info">
              <div class="info-name">
                {{ playerData.name }}
              </div>
              <div class="info-club">
                <p>Club:</p>
                <p>{{ playerData.club }}</p>
              </div>
              <div class="details-display-image club-logo">
                <img
                  :src="`https://faimages.lcp.uk.com/clubs/${playerData.clubId}.png`"
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="searchData && searchData.length < 1" class="no-results">
          No results found
        </div>
        <div class="loading-wrapper" v-if="isFetching">
          <font-awesome-icon
            class="loading-wrapper-icon"
            spin
            :icon="['fad', 'spinner-third']"
          /><span>Loading ...</span>
        </div>
      </div>
    </div>
    <div
      class="halfway"
      :class="{ 'hide-center-circle': showSearchWithResults }"
    >
      <div class="halfway-line" />
      <div class="halfway-center-circle" />
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import BaseModal from '@/components/BaseModal.vue';
import UserDetailsCapture from '@/components/UserDetailsCapture.vue';
import TermsAndConditionsWrapper from '@/components/TermsAndConditionsWrapper.vue';

@Component({
  components: {
    BaseModal,
    UserDetailsCapture,
    TermsAndConditionsWrapper,
  },
})
export default class Home extends Vue {
  public searchString = '';
  public showModal = false;



  public showTerms() {
    this.$store.commit('updateShowTerms', true);
  }


  public closeModalPopUp(): void {
    this.showModal = false;
  }

  public searchForPlayer(): void {

    if (!this.searchString) {
      (this.$refs.inputRef as HTMLInputElement).focus();
      return;
    }

    const {count, accessCode} = this.localStorageResults();
    if (count >= 3 && !accessCode) {
      this.showModal = true;
      return;
    }

    this.$store
      .dispatch('searchPlayers', this.searchString)
      .then((response: boolean) => {
        if (response) {
          const currentCount = this.localStorageResults().count;
          let newCount = (currentCount + 1).toString();
          localStorage.setItem(
            '54e931d7-077a-4d9e-93c0-e1d2d27cd71a',
            newCount
          );
        } else {
          return;
        }
      });
  }

  private localStorageResults(): { count: number; accessCode: string | null } {
    return {
      count: parseInt(localStorage.getItem(
      '54e931d7-077a-4d9e-93c0-e1d2d27cd71a'
    ) ||  "0"),
      accessCode: localStorage.getItem(
      'e918d0ce-2fe3-47f1-b4cd-0f161624f7c7'
    )
    };
  }

  public mounted() {
    const {count ,accessCode} = this.localStorageResults();
    if (count >= 5 && !accessCode) {
      this.showModal = true;
      return;
    }
  }



  public getPlayerDetails(details: any) {
    this.$store.commit('updateActivePlayer', details);
    this.$router.push(`/player-details`);
  }

  get searchData() {
    return this.$store.state.playerResults.result;
  }

  get isFetching() {
    return this.$store.state.isFetching;
  }
  get showSearchWithResults() {
    return this.$store.state.showSearchWithResults;
  }

  get showTermsAndConditions () {
    return this.$store.state.showTerms || this.$store.state.showPlayerPolicy;
  }

}
</script>

<style style lang="scss" scoped>
.home {
  position: relative;
  height: 100%;
}

.homepage-message {
  position: absolute;
  top: 25%;
  left: 50%;
  width: 60rem;
  font-size: 3rem;
  text-align: center;
  opacity: 1;
  transform: translate(-50%, -50%);
  transition: $transitionDuration $transitionTimingFunction;
  @include mix.responsive('sm') {
    width: 30rem;
    font-size: 1.8rem;
  }
  &.hide-message {
    top: 0%;
    opacity: 0;
    transition: $transitionDuration $transitionTimingFunction;
  }
}
.search {
  position: absolute;
  top: 55%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate(-50%, -50%);
  width: 100%;
  transition: top $transitionDuration $transitionTimingFunction;
  @include mix.responsive('md') {
    top: 45%;
  }
  @include mix.responsive('xs') {
    top: 50%;
  }
  &.search-with-results {
    top: 10%;
    transform: translate(-50%, -10%);
    transition: all $transitionDuration $transitionTimingFunction;
  }
  &-powered-by {
    margin-top: 2rem;
    line-height: 2.3rem;
    height: 6rem;
    span {
      padding-right: 0.5rem;
      vertical-align: bottom;
    }
    img {
      width: 10rem;
      vertical-align: top;
    }
  }
}

.loading-wrapper {
  position: absolute;
  top: 90%;
  left: 50%;
  width: 100%;
  height: 10rem;
  margin: 0 auto;
  padding-top: 7rem;
  text-align: center;
  color: #a5df07;
  transform: translate(-50%, -40%);
  &-icon {
    font-size: 6rem;
  }
  span {
    display: block;
    margin-top: 0.5rem;
  }
}

.no-results {
  padding-top: 2rem;
}
.details {
  height: auto;
  margin-bottom: 2rem;
  opacity: 0;
    @include mix.responsive('sm') {
         margin-bottom: 4rem;
    }
  &.details-results {
    position: absolute;
    bottom: 0;
    z-index: 0;
    height: calc(78vh - 15rem);
    padding-right: 1rem;
    opacity: 1;
    transform: translateY(100%);
    transition: opacity $transitionDuration $transitionTimingFunction;
    overflow-y: auto;
    @include mix.responsive('md') {
      padding-right: 1.5rem;
    }
      @include mix.responsive('sm') {
        bottom: 2rem;
    }

  }
  &-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70rem;
    padding: 1rem 2rem;
    background-color: #525252;
    border-radius: 1rem;
    cursor: pointer;
    margin-bottom: 0.5rem;
    box-shadow: 2px 2px 6px 0px rgba(22, 22, 22, 0.75);
    @include mix.responsive('md') {
      width: 60rem;
    }
    @include mix.responsive('sm') {
      width: 32rem;
      padding: 1rem;
    }
    &:hover {
      background-color: #2e2e2e;
    }
    &-image {
      flex-shrink: 0;
      width: 4rem;
      height: 4rem;
      margin-right: 1rem;
      border-radius: 50%;
      overflow: hidden;
      @include mix.responsive('xs') {
        margin-right: 1rem;
      }
      img {
        width: 100%;
      }
    }
    &-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-grow: 2;
      @include mix.responsive('xs') {
        position: relative;
        display: block;
      }
      .info-name {
        flex: 2 0 50%;
        @include mix.responsive('xs') {
          margin-bottom: 0.5rem;
        }
      }
      .info-club {
        flex: 1 0 40%;
      }
      .club-logo {
        @include mix.responsive('xs') {
          position: absolute;
          top: 1.5rem;
          right: -1.5rem;
          img {
            width: 80%;
          }
        }
      }
    }
  }
}
.details-display-name {
  margin-right: 1rem;
}

.halfway {
  position: fixed;
  bottom: 7rem;
  width: 100%;
  height: 15rem;
  overflow: hidden;
  z-index: -1;
  transform: translateY(0);
  transition: $transitionDuration $transitionTimingFunction;
  &.hide-center-circle {
    transform: translateY(150%);
    transition: $transitionDuration $transitionTimingFunction;
  }
  &-line {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1rem;
    background-color: $footballLineColor;
  }

  &-center-circle {
    position: absolute;
    left: 50%;
    width: 40rem;
    height: 40rem;
    border-radius: 50%;
    border: 1rem solid $footballLineColor;
    transform: translateX(-50%);
    @include mix.responsive('sm') {
      top: 40%;
      width: 25rem;
      height: 25rem;
    }
  }
}
</style>
